/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Style_RequiredInputs */

const cs_templates_ai_style_required = /** @type {(inputs: Templates_Ai_Style_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte referenční šablonu.`)
};

const en_templates_ai_style_required = /** @type {(inputs: Templates_Ai_Style_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reference template.`)
};

/**
* | output |
* | --- |
* | "Select a reference template." |
*
* @param {Templates_Ai_Style_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_style_required = /** @type {((inputs?: Templates_Ai_Style_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Style_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_style_required(inputs)
	return cs_templates_ai_style_required(inputs)
});